import React, { useEffect, useState } from 'react';
import { Button, message } from 'antd';
import Title from '../../components/Title/Title';
import Scanner from '../../components/Scanner/Index';
import { openApi } from '../../util/Api';
import Item from '../../components/Detail/Item';
import Date from '../../components/Formatter/Date';

const ProfileScanner = () => {
  const [loading, setLoading] = useState(false);
  const [passport, setPassport] = useState(null);

  const handleScan = (data) => {
    fetchProfileData(data);
  }

  const fetchProfileData = (number) => {
    setLoading(true);
    const url = `/scan/profile`;
    openApi.get(url, { params: { number: number } }).then(resp => {
      if (resp.data.success) {
        setPassport(resp.data.passport);
        setLoading(false);
      } else {
        setPassport(null);
        message.error('Data personel tidak ditemukan');
        setLoading(false);
      }
    }).catch(err => {
      
    });
  }

  const Rescan = () => {
    return (
      <Button onClick={() => {
        setPassport(null);
      }}>Ulangi Scan Data</Button>
    );
  }

  return (
    <div className="gx-app-login-wrap gx-mt-3" style={{display: "block"}}>
      <div className="gx-app-login-container">
        <div className="ant-card gx-p-3">
          <div className="gx-text-center">
            <Title>Cek Personel Data</Title>

            {passport ? <Rescan /> : <Scanner onScan={handleScan} />}
            
          </div>
          {loading ? 'Sedang memuat...' : passport ? <ProfileDetail passport={passport} /> : null }
        </div>
      </div>
    </div>
  );
}

export default ProfileScanner;

const ProfileDetail = ({ passport }) => {
  return (
    <div style={{border: "1px solid #ebebeb", padding: "20px", borderRadius: "5px"}}>
      <Item label="Nomor ID" value={passport.number}/>
      <Item label="Nama" value={passport.name}/>
      <Item label="Divisi Operasi" value={passport.project.division.label}/>
      <Item label="Proyek" value={passport.project.project.name}/>
      <Item label="HSE Level" value={passport.project.level ? `${passport.project.level.label}${passport.project.quality}` : `-`}/>
      <Item label="Status" value={passport.project.status.label} />
      <Item label="Hasil Induksi" value={passport.project.induction_status ? `Passed` : `Not Passed`}/>
      <Item label="Tanggal Masuk" value={<Date value={passport.project.start_date} />} />
      <Item label="Tanggal Expired" value={<Date value={passport.project.end_date} />} />
      <Item label="Perusahaan" value={passport.vendor.name}/>
      <Item label="Status Pelanggaran" value={passport.violation ? passport.violation.level.label : "Tidak ada pelanggaran"} />
    </div>
  );
}